import { render, staticRenderFns } from "./AffiliateCreditShareView.vue?vue&type=template&id=54a1c9e4&"
import script from "./AffiliateCreditShareView.vue?vue&type=script&lang=js&"
export * from "./AffiliateCreditShareView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports